import { alpha, type Theme } from "@mui/material/styles";
import type { AppPageLayoutStyles } from "../types";
import { FORM_GRID_SPACING, FORM_GRID_SPACING_COMPACT } from "../tokens";

export function buildPageLayoutStyles(theme: Theme): AppPageLayoutStyles {
  const headerBg = alpha(
    theme.palette.primary.main,
    theme.palette.mode === "dark" ? 0.1 : 0.04
  );

  return {
    pageContentShell: {
      mt: 1.5,
      mb: 2,
      width: 1,
      px: 0,
      minWidth: 0,
    },
    // ~60% less round than prior Win11 3 / 3.5 panels (3 * 0.4 ≈ 1.2)
    pageSectionCard: {
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 1.25,
      bgcolor: "background.paper",
      overflow: "hidden",
      boxShadow: theme.palette.mode === "dark"
        ? "0 1px 2px rgba(0,0,0,0.35)"
        : "0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.04)",
    },
    pageSectionCardHeader: {
      px: { xs: 1.25, sm: 1.5 },
      py: 1,
      borderBottom: "1px solid",
      borderColor: "divider",
      bgcolor: headerBg,
      flexShrink: 0,
    },
    pageSectionCardTitleBox: {
      minWidth: 0,
    },
    pageSectionCardTitleCaption: {
      display: "block",
    },
    pageSectionCardTitleCaptionWithTitle: {
      display: "block",
      mt: 0.15,
    },
    pageSectionCardBody: {
      px: { xs: 1.25, sm: 1.5 },
      pt: { xs: 1.25, sm: 1.5 },
      pb: 0,
    },
    pageSectionCardBodyNoPadding: {
      p: 0,
      flex: 1,
      minHeight: 0,
    },
    pageSectionCardFooter: {
      flexShrink: 0,
      height: 14,
      minHeight: 14,
    },
    listPageContainer: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: 1.25,
      border: "1px solid",
      borderColor: "divider",
      boxShadow: theme.palette.mode === "dark"
        ? "0 1px 2px rgba(0,0,0,0.35)"
        : "0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.04)",
      p: { xs: 1.25, sm: 1.5 },
      pb: { xs: 2, sm: 2.25 },
      m: 0,
    },
    listPagePlainInner: {
      backgroundColor: "transparent",
      borderRadius: 0,
      p: 0,
      m: 0,
    },
    dialogFormLayout: {
      p: 1.5,
      maxHeight: "min(70vh, 720px)",
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      gap: 2,
      "& .MuiOutlinedInput-root": {
        borderRadius: 1,
      },
    },
    actionsRow: {
      display: "flex",
      flexWrap: "wrap",
      gap: 0.75,
      alignItems: "center",
    },
    dataTablePanel: {
      mt: 0,
    },
    statCardLabel: {
      display: "block",
    },
    statCardLabelWithTitle: {
      display: "block",
      mb: 0.35,
    },
  };
}

export function getFormGridSpacing(compact?: boolean) {
  return compact ? FORM_GRID_SPACING_COMPACT : FORM_GRID_SPACING;
}

/** Section card with fillHeight variant styles. */
export function pageSectionCardFillStyles(fillHeight: boolean) {
  if (!fillHeight) return {};
  return {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
  };
}
